var map = {
	"./about-us-banner.webp": 219,
	"./anniversary-banner-bm.webp": 1591,
	"./anniversary-banner-cn.webp": 1592,
	"./anniversary-banner-id.webp": 1593,
	"./anniversary-banner.webp": 1594,
	"./banner-01.jpg": 1595,
	"./banner-slot.jpg": 1596,
	"./bet-and-earn-banner-cn.webp": 1597,
	"./bet-and-earn-banner-indon.webp": 1598,
	"./bet-and-earn-banner-ms.webp": 1599,
	"./bet-and-earn-banner.webp": 1600,
	"./check-in-banner-cn.webp": 1601,
	"./check-in-banner-id.webp": 1602,
	"./check-in-banner-ms.webp": 1603,
	"./check-in-banner.webp": 1604,
	"./cny_2024-bm.webp": 1605,
	"./cny_2024-cn.webp": 1606,
	"./cny_2024.webp": 1607,
	"./epl-banner-cn.jpg": 1608,
	"./epl-banner-cn.webp": 1609,
	"./epl-banner-indo.jpg": 1610,
	"./epl-banner-indo.webp": 1611,
	"./epl-banner-ms.jpg": 1612,
	"./epl-banner-ms.webp": 1613,
	"./epl-banner.jpg": 1614,
	"./epl-banner.webp": 1615,
	"./games-banner-cn.webp": 1616,
	"./games-banner-id.webp": 1617,
	"./games-banner-ms.webp": 1618,
	"./games-banner.webp": 1619,
	"./lb-m-banner-cn.webp": 1620,
	"./lb-m-banner.webp": 1621,
	"./leaderboard-banner-cn.webp": 1622,
	"./leaderboard-banner.webp": 1623,
	"./lottery-banner.webp": 1624,
	"./lottery-banners-cn.webp": 1625,
	"./lottery-banners-id.webp": 1626,
	"./lottery-banners-ms.webp": 1627,
	"./lottery-banners.webp": 1628,
	"./lucky-spin-banner-cn.webp": 1629,
	"./lucky-spin-banner-ms.webp": 1630,
	"./lucky-spin-banner-vn.webp": 1631,
	"./lucky-spin-banner.webp": 1632,
	"./p2p-banner.webp": 1633,
	"./p2p-banners-cn.webp": 1634,
	"./p2p-banners-id.webp": 1635,
	"./p2p-banners-ms.webp": 1636,
	"./p2p-banners.webp": 1637,
	"./premier-league-banner-cn.webp": 1638,
	"./premier-league-banner.webp": 1639,
	"./promos-banner-cn.webp": 1640,
	"./promos-banner-indon.webp": 1641,
	"./promos-banner-ms.webp": 1642,
	"./promos-banner.webp": 1643,
	"./promos-detail-banner.jpg": 1644,
	"./side-bar-banner.jpg": 1645,
	"./slot-banners-cn.webp": 1646,
	"./slot-banners-ms.webp": 1647,
	"./slot-banners.webp": 1648,
	"./speed-banners-cn.webp": 1649,
	"./speed-banners-ms.webp": 1650,
	"./speed-banners.webp": 1651,
	"./uefa24-prediction-bm.webp": 1652,
	"./uefa24-prediction-cn.webp": 1653,
	"./uefa24-prediction-id.webp": 1654,
	"./uefa24-prediction.webp": 1655,
	"./vip-banner-cn.webp": 1656,
	"./vip-banner-id.webp": 1657,
	"./vip-banner-ms.webp": 1658,
	"./vip-banner-vn.webp": 1659,
	"./vip-banner.webp": 1660,
	"./winner-leaderboard-banner-cn.webp": 1661,
	"./winner-leaderboard-banner.webp": 1662,
	"./world-cup-banner-cn.webp": 1663,
	"./world-cup-banner.webp": 1664,
	"./world-cup-two-banner-cn.webp": 1665,
	"./world-cup-two-banner.webp": 1666,
	"./xmas_2023-bm.jpg": 1667,
	"./xmas_2023-cn.jpg": 1668,
	"./xmas_2023-id.jpg": 1669,
	"./xmas_2023.jpg": 1670,
	"./xmas_2024-bm.webp": 1671,
	"./xmas_2024-cn.webp": 1672,
	"./xmas_2024.webp": 1673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;